import styled from "styled-components";

export const ManagementMobileComponent = styled.div`
  height: ${(props) => (props.secHeight ? props.secHeight : 0) + "px"};
  overflow: hidden;
  transition: 0.5s;
  position: relative;
  margin-top: ${(props) => (props.secHeight > 0 ? "-7vh" : 0)};
  .management {
    padding-top: 5rem;
  }
  p {
    margin: 0;
  }
  .managementmobile__bg {
    width: 55%;
    position: absolute;
    z-index: 1;
    left: -1px;
    @media (min-width: 768px) {
      width: 60%;
    }
  }
  .managementmobile__header {
    margin-top: 9.8rem;
    position: relative;
    margin-bottom: 4rem;
    @media (min-width: 768px) {
      margin-top: 21rem;
      margin-bottom: 6rem;
    }
    &--text {
      font-family: coolvetica_rg;
      font-size: 2.0275rem;
      width: 100%;
      text-align: center;
      line-height: 2rem;
      @media (min-width: 768px) {
        font-size: 2.703333333333333rem;
        line-height: 2rem;
      }
      @media (max-width: 500px) {
        line-height: 1.5rem;
      }
    }
    &--img {
      width: 28%;
      display: block;
      position: absolute;
      top: -25px;
      z-index: 1;
      margin: auto;
      left: 0;
      right: 0;
      @media (min-width: 768px) {
        width: 15%;
      }
    }
  }
  .managementmobile__purple {
    height: 55px;
    width: 100%;
    position: relative;
    background-color: #11112f;
    margin-top: 1rem;
    @media (min-width: 768px) {
      margin-top: 3rem;
    }
    &--hands {
      width: 64px;
      margin: auto;
      display: block;
      position: relative;
      top: 51%;
      transform: translateY(-15%);
      @media (min-width: 768px) {
        width: 10%;
      }
    }
    &--hands2 {
      top: 51%;
      transform: translateY(-15%);
    }
  }
  .managementmobile__section {
    margin-top: 2.5rem;
    @media (min-width: 768px) {
        margin-top: 4.5rem;
      }
    &--header {
      font-family: poppinsBold;
      font-size: 1.125rem;
      text-align: center;
      line-height: 1;
      @media (min-width: 768px) {
        font-size: 1.5rem;
      }
    }
    &--content {
      width: 85%;
      text-align: justify;
      margin: auto;
      color: #3c3c3b;
      font-family: poppinsRegular;
      font-size: 0.8125rem;
      margin-top: 0.5rem;
      @media (min-width: 768px) {
        width: 65%;
        font-size: 1.333333333333333rem;
      }
      span {
        font-family: poppinsBold;
      }
      &-blue {
        color: #11112f;
      }
      p {
        margin-bottom: 0.5rem;
      }
    }
    &--content2 {
      padding-bottom: 1rem;
    }
  }
`;
